import { render, staticRenderFns } from "./QuizSettings.vue?vue&type=template&id=f1c9443e&scoped=true&"
import script from "./QuizSettings.vue?vue&type=script&lang=ts&"
export * from "./QuizSettings.vue?vue&type=script&lang=ts&"
import style0 from "./QuizSettings.vue?vue&type=style&index=0&id=f1c9443e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c9443e",
  null
  
)

export default component.exports